import React, { useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getAisle } from "../../graphql/reloadyard/custom-queries";
import { getLocation } from "../../graphql/queries";
import { updateAisle, updateLocation } from "../../graphql/mutations";
import { Box, Slider, Typography, useMediaQuery } from "@material-ui/core";
import { useNotify } from "react-admin";
import { logError } from "../../utils/appUtils";
import { LocationType } from "../../utils/constants";
import {
  getAisleFullName,
  getLocationFullName,
  isBulkArea,
} from "../../utils/locationUtils";

const LocationCapacity = ({
  aisle,
  disabled = false,
  refreshFn,
  showName = true,
  disableAisleChange,
}) => {
  const [currentAisle, setCurrentAisle] = useState();
  const notify = useNotify();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  // Generate marks based on screen size
  let marks = [];
  for (let i = 0; i <= 100; i += isSmall ? 20 : 10) {
    marks.push({
      value: i,
      label: `${i}`,
    });
  }

  useEffect(() => {
    if (!disableAisleChange && aisle) handleAisleChange(aisle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aisle]);

  const handleAisleChange = async (aisle) => {
    if (!disabled && !aisle.locations) {
      const response = await API.graphql(
        graphqlOperation(getAisle, { id: aisle.id })
      );
      setCurrentAisle(response.data.getAisle);
    } else {
      setCurrentAisle(aisle);
    }
  };

  const handlePercentageChange = async (event, newValue) => {
    debugger;
    currentAisle.capacityUsed = newValue;
    setCurrentAisle({ ...currentAisle });
  };

  const handlePercentageChangeCommit = async (event, newValue) => {
    // setCurrentAisle({...currentAisle, capacityUsed: newValue});
    const toUpdateAisle = { id: currentAisle.id, capacityUsed: newValue };
    try {
      await API.graphql(
        graphqlOperation(updateAisle, { input: toUpdateAisle })
      );
      if (currentAisle.type === LocationType.UNSTRUCTURED) {
        const toUpdateLocation = {
          capacityUsed: newValue,
        };
        if (currentAisle.locations.items) {
          toUpdateLocation.id = currentAisle.locations.items[0].id;
        } else {
          toUpdateLocation.id = currentAisle.locations[0].id;
        }

        await API.graphql(
          graphqlOperation(updateLocation, { input: toUpdateLocation })
        );
      }

      if (refreshFn) refreshFn();
    } catch (err) {
      logError("LocationCapacity:handleLanePercentageChange", err, notify);
    }
  };

  // const capacityUsed = currentAisle?.capacityUsed || 0;

  const getCapacityUsed = () => {
    if (currentAisle?.capacityUsed) {
      let usedCapacity = currentAisle.capacityUsed;

      if (isBulkArea(currentAisle?.area) && currentAisle.bulkCapacity) {
        usedCapacity =
          (currentAisle.capacityUsed / currentAisle.bulkCapacity) * 100;
      }

      return usedCapacity.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    }
    return 0;
  };

  return (
    <>
      <Typography variant="caption" color="textSecondary" gutterBottom>
        {" "}
        {showName
          ? getAisleFullName(currentAisle) + " capacity"
          : "Capacity"}{" "}
        used {getCapacityUsed()}%
      </Typography>
      <Box ml={2} mr={2}>
        <Slider
          step={5}
          max={100}
          value={getCapacityUsed()}
          onChange={handlePercentageChange}
          onChangeCommitted={handlePercentageChangeCommit}
          marks={marks}
          disabled={disabled}
        />
      </Box>
    </>
  );
};

export const StructuredLocationCapacity = ({
  location,
  updateFn,
  disabled = false,
  refreshFn,
  showName = true,
}) => {
  const [currentLocation, setCurrentLocation] = useState();
  const notify = useNotify();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  // Generate marks based on screen size
  let marks = [];
  for (let i = 0; i <= 100; i += isSmall ? 20 : 10) {
    marks.push({
      value: i,
      label: `${i}`,
    });
  }

  useEffect(() => {
    if (location) handleLocationChange(location);
  }, [location]);

  const handleLocationChange = async (location) => {
    if (location && !location.aisle) {
      const response = await API.graphql(
        graphqlOperation(getLocation, { id: location.id })
      );
      setCurrentLocation(response.data.getLocation);
    } else {
      setCurrentLocation(location);
    }
  };

  const handlePercentageChange = async (event, newValue) => {
    currentLocation.capacityUsed = newValue;
    setCurrentLocation({ ...currentLocation });
    //         updateFn && updateFn(currentLocation);
  };

  const handlePercentageChangeCommit = async (event, newValue) => {
    const toUpdateLocation = { id: currentLocation.id, capacityUsed: newValue };
    try {
      debugger;
      await API.graphql(
        graphqlOperation(updateLocation, { input: toUpdateLocation })
      );
      updateFn && updateFn(currentLocation);
    } catch (err) {
      logError(
        "StructuredLocationCapacity:handleLanePercentageChange",
        err,
        notify
      );
    }
  };

  const capacityUsed = currentLocation?.capacityUsed
    ? currentLocation.capacityUsed
    : 0;

  return (
    <>
      <Typography variant="caption" color="textSecondary" gutterBottom>
        {" "}
        {showName
          ? getLocationFullName(currentLocation) + " capacity"
          : "Capacity"}{" "}
        used {capacityUsed}%
      </Typography>
      <Box ml={2} mr={2}>
        <Slider
          step={5}
          max={100}
          value={capacityUsed}
          onChange={handlePercentageChange}
          onChangeCommitted={handlePercentageChangeCommit}
          marks={marks}
          disabled={disabled}
        />
      </Box>
    </>
  );
};

export default LocationCapacity;
